import { createAsyncThunk } from '@reduxjs/toolkit';

import { getErrorMessage } from '@/shared/utils/error';

import type { CreateTipoPrazoDto, UpdateTipoPrazoDto } from '../types/tipoPrazoTypes';

import { tiposPrazoService } from './services';

export const listarTiposPrazo = createAsyncThunk(
  'tiposPrazo/listar',
  async (_void: void, { rejectWithValue }) => {
    try {
      return await tiposPrazoService.listar();
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  },
);

export const criarTipoPrazo = createAsyncThunk(
  'tiposPrazo/criar',
  async (data: CreateTipoPrazoDto, { rejectWithValue }) => {
    try {
      return await tiposPrazoService.criar(data);
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  },
);

export const atualizarTipoPrazo = createAsyncThunk(
  'tiposPrazo/atualizar',
  async ({ id, data }: { id: string; data: UpdateTipoPrazoDto }, { rejectWithValue }) => {
    try {
      return await tiposPrazoService.atualizar(id, data);
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  },
);

export const alternarStatusTipoPrazo = createAsyncThunk(
  'tiposPrazo/alternarStatus',
  async (id: string, { rejectWithValue }) => {
    try {
      return await tiposPrazoService.alternarStatus(id);
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  },
);
